module.exports = __webpack_public_path__ + "static/media/absence.6ba45136.svg";